export default "__VITE_ASSET__18a69983__"